// extracted by mini-css-extract-plugin
export var closeButton = "_11-1";
export var container = "_11-0";
export var fullModalImage = "_11-2";